import { Avatar, Box, Typography } from '@mui/material'
import React from 'react'
import { useGetUser } from '../../hooks/useGetUser'
import { withTranslation } from 'react-i18next'
import useTranslate from '../../utils/i18n'

const TopBar = () => {
  const { t } = useTranslate()
  const { user } = useGetUser()
  return (
    <Box display={'flex'} width={'100%'} height={'80px'} alignItems={'center'}>
      <Box display={'block'} width={'100%'}>
        <Typography fontWeight={700} variant="h4">
          {t('hello')}, {user.fullname}
        </Typography>
        <Typography variant="body2" fontSize={'10px'} mt={1} fontWeight={400}>
          {t('greeting')}
        </Typography>
      </Box>
      <Box>
        <Avatar
          src="w"
          alt={user.fullname}
          sx={{
            height: '50px',
            width: '50px',
          }}
        />
      </Box>
    </Box>
  )
}

export default withTranslation()(TopBar)
